import { createAuthStore } from '@splitfiesta/core';
import { webStorage } from '@splitfiesta/platform-web';

export type { AuthUser } from '@splitfiesta/core';

export const useAuthStore = createAuthStore({ storage: webStorage });

export const useUser = () => useAuthStore(state => state.user);
export const useIsAuthenticated = () =>
  useAuthStore(state => state.isAuthenticated);
export const useIdToken = () => useAuthStore(state => state.idToken);
export const useRefreshToken = () => useAuthStore(state => state.refreshToken);
export const useAuthLoading = () => useAuthStore(state => state.isLoading);
export const useSystemRole = () =>
  useAuthStore(state => state.user?.systemRole);
